"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureFlagImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing FeatureFlag operations. */
var FeatureFlagImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class FeatureFlag class.
   * @param client Reference to the service client
   */
  function FeatureFlagImpl(client) {
    (0, _classCallCheck2["default"])(this, FeatureFlagImpl);
    this.client = client;
  }
  /** @param options The options parameters. */


  (0, _createClass2["default"])(FeatureFlagImpl, [{
    key: "getAllFeatureFlags",
    value: function getAllFeatureFlags(options) {
      var operationArguments = {
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAllFeatureFlagsOperationSpec);
    }
    /**
     * @param name
     * @param options The options parameters.
     */

  }, {
    key: "getFeatureFlag",
    value: function getFeatureFlag(name, options) {
      var operationArguments = {
        name: name,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getFeatureFlagOperationSpec);
    }
  }]);
  return FeatureFlagImpl;
}(); // Operation Specifications


exports.FeatureFlagImpl = FeatureFlagImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getAllFeatureFlagsOperationSpec = {
  path: "/api/featureflag",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Boolean"
            }
          }
        }
      }
    }
  },
  urlParameters: [Parameters.$host],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getFeatureFlagOperationSpec = {
  path: "/api/featureflag/{name}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Boolean"
        }
      }
    },
    404: {}
  },
  urlParameters: [Parameters.$host, Parameters.name],
  headerParameters: [Parameters.accept],
  serializer: serializer
};